var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.filePath !== null)?_c(require(("@/assets/images/" + _vm.filePath + ".svg")).default,_vm._b({tag:"Component",staticClass:"svgImport",on:{"v-on":_vm.$listeners}},'Component',_vm.$attrs,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }